import React from 'react';
import { useState, useEffect } from 'react';
import PageTitle from '../../common/components/PageTitle';
import {
  Grid,
  Stack,
  Divider,
  Typography,
  Paper,
  Button,
  CircularProgress,
} from '@mui/material';
import { styled } from '@mui/system';
import { AvatarDisplay } from '../../common/components/AvatarDisplay';
import { selectBilling } from '../../common/subscription/BillingSlice';
import { useSelector } from 'react-redux';
import { CreditCardIcon } from './CreditCardIcon';
import EditIcon from '@mui/icons-material/Edit';
import UpdateBillingInfoForm from './UpdateBillingInfoForm';
import { RecurlyProvider, Elements } from '@recurly/react-recurly';
import { handleFetchBillingDetails } from '../../common/subscription/SubscriptionService';

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: 0,
  margin: theme.spacing(0.5),
}));

const LeftItem = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: 0,
  margin: theme.spacing(0.5),
  width: '98%',
  textAlign: 'left',
}));

export function Billing() {
  const [loading, setLoading] = useState(false);
  const BillingInfo = useSelector(selectBilling);
  const [editingBillingInfo, setEditingProfileBillingInfo] = useState(false);

  useEffect(() => {
    setLoading(true);
    handleFetchBillingDetails()
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  return (
    <>
      <PageTitle title='Billing' />
      <Grid
        container
        alignItems='flex-start'
        justifyContent='center'
        direction='row'
      >
        <Grid item xs={12} md={6}>
          <AvatarDisplay />
        </Grid>
        <Grid item xs={12} md={6}>
          {loading ? (
            <>
              <Grid container spacing={10}>
                <Grid item xs={12}>
                  <CircularProgress color='secondary' />
                </Grid>
              </Grid>
            </>
          ) : editingBillingInfo ? (
            <Stack alignItems='center' justifyContent='center'>
              <Item>
                <Typography variant='h5'>Edit Billing Information</Typography>
              </Item>
              <Item sx={{ width: '50%' }}>
                <Divider />
              </Item>
              <Item>
                <RecurlyProvider
                  publicKey={process.env.REACT_APP_RECURLY_PUBLIC_API_KEY}
                >
                  <Elements>
                    <UpdateBillingInfoForm
                      callback={() => setEditingProfileBillingInfo(false)}
                    />
                  </Elements>
                </RecurlyProvider>
              </Item>
            </Stack>
          ) : (
            <Stack alignItems='center' justifyContent='center'>
              <Item>
                <Typography variant='h5'>
                  Current Billing Information
                </Typography>
              </Item>
              <Item sx={{ width: '50%' }}>
                <Divider />
              </Item>
              <LeftItem>
                <Typography>
                  <b>Name on Card</b>
                  <br /> {BillingInfo.BillingFirstName}{' '}
                  {BillingInfo.BillingLastName}
                </Typography>
              </LeftItem>
              <LeftItem>
                <Typography>
                  <b>Credit Card</b>
                  <br />
                  <CreditCardIcon
                    cardType={BillingInfo.PaymentMethodCardType}
                    width='30px'
                  />{' '}
                  ***
                  {BillingInfo.PaymentMethodLastFour}{' '}
                  {BillingInfo.PaymentMethodExpMonth}/
                  {BillingInfo.PaymentMethodExpYear}{' '}
                </Typography>
              </LeftItem>
              <LeftItem>
                <Typography>
                  <b>Billing Country</b>
                  <br /> {BillingInfo.BillingAddressCountry}
                </Typography>
              </LeftItem>
              <LeftItem>
                <Typography>
                  <b>Billing Postal Code</b>
                  <br />
                  {BillingInfo.BillingAddressPostalCode}
                </Typography>
              </LeftItem>
              <Item>
                <Button
                  variant='contained'
                  color='secondary'
                  onClick={() => setEditingProfileBillingInfo(true)}
                >
                  <EditIcon style={{ marginRight: '5' }} />
                  Edit Billing Info
                </Button>
              </Item>
            </Stack>
          )}
        </Grid>
      </Grid>
    </>
  );
}
